/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PermissionsGuard} from './permissions.guard';
import {ErrorPageComponent} from './shared/error-page/error-page.component';
import {WelcomePageComponent} from './welcome-page/welcome-page.component';
import {WelcomePageGuard} from './welcome-page/welcome-page.guard';
import {AboutComponent} from './about/about.component';
import {SpoRoutingModule} from './spo/spo-routing.module';
import {SettingsRoutingModule} from './settings/settings-routing.module';
import {ClaimRoutingModule} from './claim/claim-routing.module';
import {HomePageComponent} from './home-page/home-page.component';
import {HomePageModule} from './home-page/home-page.module';
import {PartNumberChangesRoutingModule} from './part-number-changes/part-number-changes-routing.module';
import {SettlementsRoutingModule} from './settlements/settlements-routing.module';
import {BundlesRoutingModule} from './bundles/bundles-routing.module';
import {DashboardRoutingModule} from './dashboard/dashboard-routing.module';
import {TrainingMaterialsRoutingModule} from './training-materials/training-materials-routing.module';

export const routes: Routes = [
    {
        path: 'welcome-page',
        component: WelcomePageComponent,
        canActivate: [WelcomePageGuard],
        data: {
            breadcrumb: 'Welcome'
        }
    },
    {
        path: 'about-page',
        component: AboutComponent
    },
    {
        path: '',
        component: HomePageComponent,
        pathMatch: 'full',
        canActivate: [PermissionsGuard]
    },
    {
        path: '**',
        redirectTo: 'error'
    },
    {
        path: 'error',
        component: ErrorPageComponent,
        data: {
            hideBreadcrumbs: true
        }
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
        HomePageModule,
        SpoRoutingModule,
        SettingsRoutingModule,
        ClaimRoutingModule,
        PartNumberChangesRoutingModule,
        SettlementsRoutingModule,
        BundlesRoutingModule,
        DashboardRoutingModule,
        TrainingMaterialsRoutingModule
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
